import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import callrecorderApi from '../../api/callrecorderApi';
import callrecorderUrls from "../../configs/callrecorder/callrecorderUrls";
import { SmsPackageInterface } from '../../store/callrecorder/smsPackagesSlice';

const PREFIX = 'callrecorder';

const processStrategy = (value: any) => {
  return {
    ...value,
    url: callrecorderUrls.smsPackagePath(value.id)
  };
}

export const smsPackagesEntity = new schema.Entity(
  'sms_packages',
  {},
  {
    processStrategy
  }
);

export const smsPackageEntity = new schema.Entity(
  'sms_package',
  {},
  {
    processStrategy
  }
);

const fetchSmsPackagesCollection = async (url: string, params: object = {}) => {
  const response = await callrecorderApi.get(url, { params })
  const normalized = normalize<
    any,
    {
      sms_packages: { [key: string]: SmsPackageInterface };
    }
  >(response.data.sms_packages, [smsPackagesEntity]);

  return {
    smsPackages: normalized.entities?.sms_packages || {},
    ids: normalized.result,
    count: response.data.meta?.total_count
  };
}

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<
    any,
    { sms_package: SmsPackageInterface; }
  >(response.data.sms_package, smsPackageEntity);
  return normalized.entities;
}

export const fetchSmsPackages = createAsyncThunk(
  `${PREFIX}_sms_packages/fetchSmsPackages`,
  async (params: object = {}) => fetchSmsPackagesCollection('/onesky/sms_packages', params)
);

export const fetchSmsPackage = createAsyncThunk(
  `${PREFIX}_sms_packages/fetchSmsPackage`,
  async (id: number | string) => {
    const response = await callrecorderApi.get(`/onesky/sms_packages/${id}`);
    return normalizeInstance(response);
  }
);

export const createSmsPackage = createAsyncThunk(
  `${PREFIX}_sms_packages/createSmsPackage`,
  async (data: object, { rejectWithValue }) => {
    try {
      const response = await callrecorderApi.post(`/onesky/sms_packages`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

export const updateSmsPackage = createAsyncThunk(
  `${PREFIX}_sms_packages/updateSmsPackage`,
  async ({ id, data }: { id: number, data: object }, { rejectWithValue }) => {
    try {
      const response = await callrecorderApi.patch(`/onesky/sms_packages/${id}`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);
